import { DtOrg } from '@ow/ditto-core'

const { validation, transformer, filterSpec } = DtOrg
export { default as Render } from './render'
// export { default as validation } from './validation'
export { default as Filter } from './filter'
// export { filterSpec } from './config'
// export { default as transformer } from './transformer'
export { validation, transformer, filterSpec }
